import React, { Component } from 'react'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Icon from '@material-ui/core/Icon'

import { Fonts, Colors } from '../theme'
import { localize } from '../util/Localizer'

class ProvidersSearchInput extends Component {
  constructor (props) {
    super(props)
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this)
    this.state = {}
  }

  initAutocomplete = () => {
    const { Autocomplete } = this.props.autocomplete
    this.autocomplete = new Autocomplete(document.getElementById('autocomplete'), {
      types: ['geocode', 'establishment'],
      componentRestrictions: { country: 'ca' }
    })

    this.autocomplete.addListener('place_changed', this.handlePlaceChanged)
  }

  handlePlaceChanged () {
    if (this.autocomplete.getPlace().geometry) {
      this.props.handleLatLng({
        lat: this.autocomplete.getPlace().geometry.location.lat(),
        lng: this.autocomplete.getPlace().geometry.location.lng()
      })
      this.props.onChange(this.autocomplete.getPlace().formatted_address)
    } else {
      this.props.errorHandler(localize('pages.providers.search.error.invalidAddress'))
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.autocomplete !== prevProps.autocomplete) {
      this.initAutocomplete()
    }
  }

  render () {
    const props = this.props
    const { classes = {} } = this.props
    return (

      <FormControl className={props.readOnly && 'disabled'} error={!!props.errorText} fullWidth={props.fullWidth} style={{ margin: '10x 0', cursor: props.readOnly && 'not-allowed' }}>
        <InputLabel
          htmlFor={props.id}
          style={{
            cursor: props.readOnly && 'not-allowed',
            color: props.readOnly ? Colors.Palette.disabledTextColor : Colors.Palette.primaryTextColor,
            fontFamily: Fonts.primaryFontFamily
          }}
          shrink={props.floatingLabelFixed}
        >
          {props.floatingLabelText}
        </InputLabel>
        <Input
          className="searchInput"
          id='autocomplete'
          placeholder={props.defaultText}
        />
        <Icon className={classes.borderedIcon}>search</Icon>
      </FormControl>
    )
  }
}

export default ProvidersSearchInput



// WEBPACK FOOTER //
// ./src/controls/ProvidersSearchInput.js